/*!
 * PXG Australia club configurator UI (NEW file, not Dawn core).
 * Renders the per-category build flow (UK pxg.com style) from pxg_* metaobjects.
 * All pricing/rules live in pxg-config-engine.js (unit tested); this file is presentation + cart add.
 */
(function () {
  'use strict';

  var LABELS = {
    hand: 'Dexterity', model: 'Head model', finish: 'Head colour', hosel: 'Hosel', clubs: 'Club selection',
    loft: 'Loft', wedgeLoft: 'Loft – Bounce', material: 'Shaft material', bucket: 'Shaft flex', shaft: 'Shaft', grip: 'Grip', gripSize: 'Grip size'
  };
  var SETS = [['4', 'PW'], ['5', 'PW'], ['5', 'GW'], ['4', 'GW'], ['6', 'PW']];

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function uniq(a) { var o = []; a.forEach(function (x) { if (x != null && o.indexOf(x) < 0) o.push(x); }); return o; }
  function arr(v) { return Array.isArray(v) ? v : (v ? [v] : []); }

  function Configurator(root, data) {
    this.root = root;
    this.E = window.PXGEngine;
    this.section = root.closest('.pxg-pdp');
    this.ack = root.getAttribute('data-ack') || '';
    this.variantPrices = {};
    data.variants = this.mapVariants(data.skus || {});
    this.cat = new this.E.Catalogue(data);
    this.heads = this.cat.heads.filter(function (h) { return true; });
    if (!this.heads.length) { root.innerHTML = '<p class="pxg-cfg__note">This club is not available to build online yet. Please contact us to order.</p>'; return; }
    this.st = this.E.defaults(this.cat, this.heads);
    this.applyUrl();
    this.ui = { shaftOpen: false, gripOpen: false, fitOpen: false, acked: false, busy: false, error: '' };
    this.integrity = this.checkIntegrity();
    this.bind();
    this.render();
    this.initGallery();
    this.initBuyBar();
  }

  /** Deep links (quizzes, emails): ?head=<pxg_head handle>&hand=Left|Right&hosel=<hosel label>. Invalid values are ignored. */
  Configurator.prototype.applyUrl = function () {
    var q; try { q = new URLSearchParams(window.location.search); } catch (e) { return; }
    var E = this.E, hd = q.get('head'), hand = q.get('hand'), hosel = q.get('hosel');
    var pick = hd && this.heads.filter(function (h) { return h.handle === hd; })[0];
    if (pick) this.st = E.defaults(this.cat, [pick].concat(this.heads.filter(function (h) { return h !== pick; })));
    if (hand === 'Left' || hand === 'Right') this.st.hand = hand;
    if (hosel) this.st.hosel = hosel;
    E.normalise(this.cat, this.heads, this.st);
  };

  Configurator.prototype.mapVariants = function (skus) {
    var v = { heads: {}, upgrades: {} }, self = this;
    Object.keys(skus).forEach(function (sku) {
      var rec = skus[sku], m;
      self.variantPrices[rec.id] = rec.price;
      if ((m = /^CU-(\d+(?:\.\d+)?)$/.exec(sku))) { v.upgrades[String(Math.round(parseFloat(m[1]) * 100))] = rec.id; return; }
      if ((m = /^CB-(.+?)(?:-(ST|GR))?$/.exec(sku))) {
        var basis = m[2] === 'ST' ? 'Steel' : m[2] === 'GR' ? 'Graphite' : 'Standard';
        (v.heads[m[1]] = v.heads[m[1]] || {})[basis] = rec.id;
      }
    });
    return v;
  };

  /** Every price the customer sees must equal the price Shopify will charge. */
  Configurator.prototype.checkIntegrity = function () {
    var E = this.E, cat = this.cat, vp = this.variantPrices, bad = [];
    this.heads.forEach(function (h) {
      var v = cat.variants.heads[h.handle] || {};
      if (h.graphite_price_aud) {
        if (vp[v.Steel] !== E.cents(h.base_price_aud)) bad.push(h.handle + ' steel');
        if (vp[v.Graphite] !== E.cents(h.graphite_price_aud)) bad.push(h.handle + ' graphite');
      } else if (vp[v.Standard] !== E.cents(h.base_price_aud)) bad.push(h.handle);
    });
    var ups = uniq(cat.shafts.map(function (s) { return E.cents(s.upcharge_aud); }).concat(cat.grips.map(function (g) { return E.cents(g.upcharge_aud); }))).filter(Boolean);
    ups.forEach(function (c) { if (vp[cat.variants.upgrades[c]] !== c) bad.push('upgrade ' + E.money(c)); });
    if (bad.length && window.console) console.error('[PXG configurator] price mismatch between catalogue and build products:', bad);
    return bad;
  };

  // ---------- state ----------
  Configurator.prototype.set = function (key, val) {
    var st = this.st, E = this.E;
    if (key === 'model') {
      var cur = this.cat.head(st.head), want = this.heads.filter(function (h) { return h.model === val; });
      var same = want.filter(function (h) { return h.finish === cur.finish; })[0] || want[0];
      st.head = same.handle;
    } else if (key === 'finish') {
      var head = this.cat.head(st.head);
      if (E.category(head) === 'putter') st.finish = val;
      else { var f = this.heads.filter(function (h) { return h.model === head.model && h.finish === val; })[0]; if (f) st.head = f.handle; }
      this.showFinishImage(val);
    } else if (key === 'club') {
      var lofts = this.cat.head(st.head).lofts, i = st.clubs.indexOf(val);
      if (i >= 0) { if (st.clubs.length > 1) st.clubs.splice(i, 1); }
      else st.clubs.push(val);
      st.clubs.sort(function (a, b) { return lofts.indexOf(a) - lofts.indexOf(b); });
    } else if (key === 'set') {
      var lf = this.cat.head(st.head).lofts, ab = val.split('|');
      st.clubs = lf.slice(lf.indexOf(ab[0]), lf.indexOf(ab[1]) + 1);
    } else if (key === 'loftOne') st.clubs = [val];
    else if (key === 'wedgeLoft') st.loft = val;
    else if (key === 'shaft') { st.shaft = val; this.ui.shaftOpen = false; }
    else if (key === 'grip') { st.grip = val; this.ui.gripOpen = false; }
    else st[key] = val;
    this.E.normalise(this.cat, this.heads, st);
    this.ui.error = '';
    this.render();
  };

  // ---------- render ----------
  Configurator.prototype.pills = function (key, items, current, opts) {
    opts = opts || {};
    return '<div class="pxg-pills' + (opts.cls ? ' ' + opts.cls : '') + '" role="' + (opts.multi ? 'group' : 'radiogroup') + '" aria-label="' + esc(opts.label || LABELS[key] || key) + '">' +
      items.map(function (it) {
        var on = opts.multi ? current.indexOf(it.value) >= 0 : it.value === current;
        return '<button type="button" class="pxg-pill' + (on ? ' is-on' : '') + (it.disabled ? ' is-off' : '') + '"' +
          (opts.multi ? ' aria-pressed="' + on + '"' : ' role="radio" aria-checked="' + on + '"') +
          (it.disabled ? ' disabled aria-disabled="true"' : '') + ' data-set="' + esc(key) + '" data-val="' + esc(it.value) + '" data-key="' + esc(key + ':' + it.value) + '">' +
          (it.swatch ? '<span class="pxg-swatch pxg-swatch--' + esc(String(it.swatch).toLowerCase().replace(/[^a-z]/g, '')) + '" aria-hidden="true"></span>' : '') +
          '<span>' + esc(it.label) + '</span>' + (it.sub ? '<small>' + esc(it.sub) + '</small>' : '') + '</button>';
      }).join('') + '</div>';
  };

  Configurator.prototype.field = function (name, label, value, body, note) {
    return '<div class="pxg-field" data-field="' + name + '"><div class="pxg-field__head"><span class="pxg-field__label">' + esc(label) + '</span>' +
      (value ? '<span class="pxg-field__value">' + esc(value) + '</span>' : '') + '</div>' + body + (note ? '<p class="pxg-field__note">' + note + '</p>' : '') + '</div>';
  };

  Configurator.prototype.render = function () {
    var E = this.E, cat = this.cat, st = this.st, h = cat.head(st.head), c = E.category(h), p = E.price(cat, st), self = this, html = '';
    var focusKey = document.activeElement && this.root.contains(document.activeElement) ? document.activeElement.getAttribute('data-key') : null;

    // Dexterity
    var lhOk = E.lhAvailable(h), lhNote = '';
    if (!lhOk) lhNote = 'Left-handed is not available for this model.';
    else if (/custom order/i.test(h.lh || '')) lhNote = 'Left-handed is a custom order from PXG USA' + (E.lhLofts(h) ? ' (' + E.lhLofts(h).map(function (l) { return l + '°'; }).join(', ') + ' only)' : '') + '.';
    html += this.field('hand', LABELS.hand, st.hand === 'Left' ? 'Left-handed' : 'Right-handed',
      this.pills('hand', [{ value: 'Right', label: 'Right' }, { value: 'Left', label: 'Left', disabled: !lhOk }], st.hand), st.hand === 'Left' || !lhOk ? esc(lhNote) : '');

    // Head model
    var models = uniq(this.heads.map(function (x) { return x.model; }));
    if (models.length > 1) html += this.field('model', LABELS.model, h.model, this.pills('model', models.map(function (m) { return { value: m, label: self.shortModel(m) }; }), h.model));

    // Head colour
    var finishes = c === 'putter' ? arr(h.finish_options) : uniq(this.heads.filter(function (x) { return x.model === h.model; }).map(function (x) { return x.finish; }));
    var curFinish = c === 'putter' ? st.finish : h.finish;
    if (finishes.length > 1 || (c === 'putter' && finishes.length === 1)) {
      var priceByFinish = {};
      if (c !== 'putter') this.heads.forEach(function (x) { if (x.model === h.model) priceByFinish[x.finish] = E.cents(st.material === 'Graphite' && x.graphite_price_aud ? x.graphite_price_aud : x.base_price_aud); });
      var base = priceByFinish[curFinish];
      html += this.field('finish', LABELS.finish, curFinish, this.pills('finish', finishes.map(function (f) {
        var d = priceByFinish[f] != null ? priceByFinish[f] - base : 0;
        return { value: f, label: f, swatch: f, sub: d > 0 ? '+' + E.money(d) : (d < 0 ? '−' + E.money(-d) : '') };
      }), curFinish, { cls: 'pxg-pills--swatch' }));
    }

    // Hosel (putters)
    var hos = E.hosels(h, st.finish);
    if (hos.length) html += this.field('hosel', LABELS.hosel, st.hosel, this.pills('hosel', hos.map(function (x) { return { value: x, label: x }; }), st.hosel));

    // Club selection / loft
    if (c === 'iron') {
      var sets = SETS.filter(function (s) { return h.lofts.indexOf(s[0]) >= 0 && h.lofts.indexOf(s[1]) > h.lofts.indexOf(s[0]); })
        .map(function (s) { var on = st.clubs.join() === h.lofts.slice(h.lofts.indexOf(s[0]), h.lofts.indexOf(s[1]) + 1).join(); return '<button type="button" class="pxg-chip' + (on ? ' is-on' : '') + '" data-set="set" data-val="' + s[0] + '|' + s[1] + '" data-key="set:' + s[0] + s[1] + '">' + s[0] + '–' + s[1] + '</button>'; }).join('');
      html += this.field('clubs', LABELS.clubs, st.clubs.length + (st.clubs.length === 1 ? ' club' : ' clubs'),
        '<div class="pxg-sets"><span>Quick sets</span>' + sets + '</div>' +
        this.pills('club', h.lofts.map(function (l) { return { value: l, label: l }; }), st.clubs, { multi: true, cls: 'pxg-pills--grid', label: LABELS.clubs }),
        'Choose each club in your set. Price is per club.');
    } else if (c === 'wedge') {
      var lo = E.loftOptions(h);
      html += this.field('wedgeLoft', LABELS.wedgeLoft, st.loft, this.pills('wedgeLoft', lo.map(function (o) { return { value: o.label, label: o.label }; }), st.loft, { cls: 'pxg-pills--loft' }));
    } else if (c === 'driver' || c === 'fairway' || c === 'hybrid') {
      var al = E.availableLofts(h, st.hand);
      html += this.field('loft', c === 'fairway' ? 'Club' : LABELS.loft, E.loftLabel(h, st.clubs[0]),
        this.pills('loftOne', h.lofts.map(function (l) { return { value: l, label: E.loftLabel(h, l), disabled: al.indexOf(l) < 0 }; }), st.clubs[0], { label: LABELS.loft }));
    }

    // Shaft material
    var mats = E.materials(cat, h);
    if (mats.length > 1) {
      var gUp = h.graphite_price_aud ? E.cents(h.graphite_price_aud) - E.cents(h.base_price_aud) : 0;
      html += this.field('material', LABELS.material, st.material, this.pills('material', mats.map(function (m) { return { value: m, label: m, sub: m === 'Graphite' && gUp ? '+' + E.money(gUp) + ' per club' : '' }; }), st.material));
    }

    // Flex
    var buckets = E.bucketsFor(cat, h, st.material);
    if (buckets.some(function (b) { return b.available; })) {
      html += this.field('bucket', LABELS.bucket, st.bucket, this.pills('bucket', buckets.map(function (b) { return { value: b.value, label: b.value, disabled: !b.available }; }), st.bucket, { cls: 'pxg-pills--flex' }));
    }

    // Shaft
    var shafts = E.shaftsFor(cat, h, st.material, st.bucket);
    html += this.field('shaft', LABELS.shaft, '', this.optionCard('shaft', p.shaftOpt ? p.shaftOpt.label : '–', this.shaftSpec(p.shaftOpt), p.shaft, shafts.length > 1, this.ui.shaftOpen) +
      (this.ui.shaftOpen ? this.optionList('shaft', shafts.map(function (o) { return { value: o.key, label: o.label, spec: self.shaftSpec(o), up: o.up }; }), st.shaft) : ''));

    // Grip
    var grips = cat.gripOptions(h);
    html += this.field('grip', LABELS.grip, '', this.optionCard('grip', p.gripRec ? p.gripRec.label : '–', p.gripRec ? (p.gripRec.brand || '') : '', p.grip, grips.length > 1, this.ui.gripOpen) +
      (this.ui.gripOpen ? this.optionList('grip', grips.map(function (g) { return { value: g.handle, label: g.label, spec: g.brand, up: E.cents(g.upcharge_aud) }; }), st.grip) : ''));
    var sizes = p.gripRec ? arr(p.gripRec.sizes) : [];
    if (sizes.length > 1) html += this.field('gripSize', LABELS.gripSize, st.gripSize, this.pills('gripSize', sizes.map(function (s) { return { value: s, label: s }; }), st.gripSize));

    // Fit specs (inline accordion, replaces UK "Advanced Configurations" popup)
    html += this.fitSpecs(h, c);

    // Summary + add
    html += this.summary(h, c, p);

    this.root.innerHTML = html;
    this.updatePrice(p);
    if (focusKey) { var el = this.root.querySelector('[data-key="' + focusKey.replace(/"/g, '\\"') + '"]'); if (el) el.focus({ preventScroll: true }); }
  };

  /** Strip words every model shares ("Lightning … Driver" -> "Tour", "Max 10K") so pills stay short. */
  Configurator.prototype.shortModel = function (m) {
    var models = uniq(this.heads.map(function (x) { return x.model; })).map(function (x) { return x.split(' '); });
    if (models.length < 2) return m;
    var w = m.split(' '), pre = 0, suf = 0;
    while (models.every(function (x) { return x.length > pre + 1 && x[pre] === models[0][pre]; })) pre++;
    while (models.every(function (x) { return x.length > pre + suf + 1 && x[x.length - 1 - suf] === models[0][models[0].length - 1 - suf]; })) suf++;
    var out = w.slice(pre, w.length - suf).join(' ');
    return out || m;
  };
  Configurator.prototype.shaftSpec = function (o) {
    if (!o) return '';
    var s = o.shaft, bits = [];
    if (o.flex) bits.push('Flex ' + o.flex + (o.bucket ? ' (' + o.bucket + ')' : ''));
    if (o.weight && o.label.indexOf(o.weight) < 0) bits.push(o.weight);
    if (s.category !== 'Putter') bits.push(s.material);
    return bits.join(' · ');
  };
  Configurator.prototype.optionCard = function (kind, title, spec, up, canChange, open) {
    var E = this.E;
    return '<div class="pxg-option-card"><div class="pxg-option-card__body"><strong>' + esc(title) + '</strong>' + (spec ? '<span>' + esc(spec) + '</span>' : '') + '</div>' +
      '<span class="pxg-option-card__price">' + (up ? '+' + E.money(up) + ' <small>per club</small>' : 'Included') + '</span>' +
      (canChange ? '<button type="button" class="pxg-link" data-toggle="' + kind + '" aria-expanded="' + open + '" data-key="toggle:' + kind + '">' + (open ? 'Close' : 'Change ' + kind) + '</button>' : '') + '</div>';
  };
  Configurator.prototype.optionList = function (kind, items, current) {
    var E = this.E, stock = items.filter(function (i) { return !i.up; }), ups = items.filter(function (i) { return i.up; });
    function rows(list) {
      return list.map(function (i) {
        var on = i.value === current;
        return '<button type="button" role="radio" aria-checked="' + on + '" class="pxg-option-row' + (on ? ' is-on' : '') + '" data-set="' + kind + '" data-val="' + esc(i.value) + '" data-key="' + kind + ':' + esc(i.value) + '">' +
          '<span class="pxg-radio" aria-hidden="true"></span><span class="pxg-option-row__text"><strong>' + esc(i.label) + '</strong>' + (i.spec ? '<small>' + esc(i.spec) + '</small>' : '') + '</span>' +
          '<span class="pxg-option-row__price">' + (i.up ? '+' + E.money(i.up) : 'Included') + '</span></button>';
      }).join('');
    }
    return '<div class="pxg-option-list" role="radiogroup" aria-label="' + kind + ' options">' +
      (stock.length ? '<p class="pxg-option-list__group">Stock – no charge</p>' + rows(stock) : '') +
      (ups.length ? '<p class="pxg-option-list__group">Upgrades – price per club</p>' + rows(ups) : '') + '</div>';
  };

  Configurator.prototype.fitSpecs = function (h, c) {
    var E = this.E, st = this.st, s = this.cat.setting(h), rows = [], chips = [];
    function sel(key, label, list, val) {
      if (!arr(list).length) return;
      chips.push(label + ': ' + val);
      rows.push('<label class="pxg-fit__row"><span>' + esc(label) + '</span><select data-select="' + key + '" data-key="sel:' + key + '">' +
        arr(list).map(function (o) { return '<option' + (o === val ? ' selected' : '') + '>' + esc(o) + '</option>'; }).join('') + '</select></label>');
    }
    sel('loftAdj', 'Loft', s.loft_adjust, st.loftAdj);
    sel('lieAdj', 'Lie', s.lie_adjust, st.lieAdj);
    sel('length', 'Length', s.length_adjust, st.length);
    sel('papers', 'Grip build-up', s.grip_papers, st.papers);
    sel('install', 'Grip install', s.grip_install, st.install);
    if (!rows.length) return '';
    var std = '';
    if (c === 'wedge') {
      var lo = E.loftOptions(h).filter(function (o) { return o.label === st.loft; })[0];
      if (lo && lo.std_length_in) std = 'Standard for ' + lo.label + ': ' + lo.std_length_in + '″ length, ' + lo.std_lie + '° lie.';
    }
    var open = this.ui.fitOpen;
    var custom = chips.filter(function (x) { return !/: (Standard|No additional papers|34″|45″)$/.test(x); }).length;
    return '<div class="pxg-field pxg-fit' + (open ? ' is-open' : '') + '" data-field="fit">' +
      '<button type="button" class="pxg-fit__toggle" data-toggle="fit" aria-expanded="' + open + '" data-key="toggle:fit">' +
      '<span class="pxg-field__label">Fit specs</span><span class="pxg-fit__summary">' + (custom ? custom + ' custom' : 'All standard') + '</span><span class="pxg-chevron" aria-hidden="true"></span></button>' +
      (open ? '<div class="pxg-fit__body">' + rows.join('') + (std ? '<p class="pxg-field__note">' + esc(std) + '</p>' : '') +
        '<p class="pxg-field__note">Not sure? Leave everything at Standard, or <a href="' + esc(this.root.getAttribute('data-fit-url') || '#') + '">book a fitting</a>.</p></div>'
        : '<div class="pxg-fit__chips">' + chips.map(function (x) { return '<span>' + esc(x) + '</span>'; }).join('') + '</div>') + '</div>';
  };

  Configurator.prototype.summary = function (h, c, p) {
    var E = this.E, st = this.st, lines = [];
    lines.push(['Head' + (p.headBasis === 'Graphite' ? ' (graphite build)' : ''), E.money(p.head)]);
    lines.push(['Shaft – ' + (p.shaftOpt ? p.shaftOpt.label : ''), p.shaft ? '+' + E.money(p.shaft) : 'Included']);
    lines.push(['Grip – ' + (p.gripRec ? p.gripRec.label : ''), p.grip ? '+' + E.money(p.grip) : 'Included']);
    var multi = p.clubs > 1;
    var blocked = this.integrity.length > 0;
    return '<div class="pxg-summary">' +
      '<dl class="pxg-summary__lines">' + lines.map(function (l) { return '<div><dt>' + esc(l[0]) + '</dt><dd>' + esc(l[1]) + '</dd></div>'; }).join('') +
      (multi ? '<div class="pxg-summary__per"><dt>Per club</dt><dd>' + E.money(p.perClub) + '</dd></div><div><dt>× ' + p.clubs + ' clubs (' + esc(st.clubs.join(', ')) + ')</dt><dd></dd></div>' : '') +
      '<div class="pxg-summary__total"><dt>Total</dt><dd>' + E.money(p.total) + '</dd></div></dl>' +
      '<label class="pxg-ack"><input type="checkbox" data-ack-box' + (this.ui.acked ? ' checked' : '') + ' data-key="ack"><span>' + esc(this.ack) + '</span></label>' +
      (this.ui.error ? '<p class="pxg-error" role="alert">' + esc(this.ui.error) + '</p>' : '') +
      (blocked ? '<p class="pxg-error" role="alert">Online ordering for this club is temporarily unavailable while we update pricing. Please contact us to order.</p>' : '') +
      '<button type="button" class="pxg-btn pxg-btn--primary pxg-add" data-add data-key="add"' + (blocked || this.ui.busy ? ' disabled' : '') + '>' +
      (this.ui.busy ? 'Adding…' : 'Add to cart · ' + E.money(p.total)) + '</button></div>';
  };

  Configurator.prototype.updatePrice = function (p) {
    var E = this.E, box = this.section && this.section.querySelector('[data-pxg-price]');
    if (box) box.innerHTML = '<span class="pxg-pdp__price-total">' + E.money(p.total) + '</span>' +
      (p.clubs > 1 ? '<span class="pxg-pdp__price-per">' + E.money(p.perClub) + ' per club × ' + p.clubs + '</span>' : '');
    var bt = this.section && this.section.querySelector('[data-pxg-buybar-total]');
    if (bt) bt.textContent = E.money(p.total);
  };

  // ---------- events ----------
  Configurator.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b || !self.root.contains(b) || b.disabled) return;
      if (b.hasAttribute('data-set')) {
        var k = b.getAttribute('data-set'), v = b.getAttribute('data-val');
        self.set(k === 'club' ? 'club' : k, v);
      } else if (b.hasAttribute('data-toggle')) {
        var t = b.getAttribute('data-toggle');
        self.ui[t + 'Open'] = !self.ui[t + 'Open'];
        if (t === 'shaft') self.ui.gripOpen = false;
        if (t === 'grip') self.ui.shaftOpen = false;
        self.render();
      } else if (b.hasAttribute('data-add')) self.add();
    });
    this.root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.hasAttribute('data-select')) self.set(t.getAttribute('data-select'), t.value);
      else if (t.hasAttribute('data-ack-box')) { self.ui.acked = t.checked; if (t.checked && /acknowledge/.test(self.ui.error)) { self.ui.error = ''; self.render(); } }
    });
  };

  Configurator.prototype.add = function () {
    var self = this, E = this.E;
    if (!this.ui.acked) { this.ui.error = 'Please acknowledge the custom build lead time to continue.'; this.render(); var a = this.root.querySelector('[data-ack-box]'); if (a) a.focus(); return; }
    var id = 'B' + Date.now().toString(36).toUpperCase() + Math.random().toString(36).slice(2, 6).toUpperCase(), lines;
    try { lines = E.cartLines(this.cat, this.st, id); } catch (err) { this.ui.error = 'Sorry, this combination can\'t be ordered online. Please contact us.'; this.render(); return; }
    // Final guard: what Shopify charges must equal what we showed.
    var charge = lines.reduce(function (t, l) { return t + (self.variantPrices[l.id] || 0) * l.quantity; }, 0);
    if (charge !== E.price(this.cat, this.st).total) { this.ui.error = 'Pricing is being updated for this club. Please contact us to order.'; this.render(); return; }
    var drawer = document.querySelector('cart-drawer');
    var body = { items: lines };
    if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    this.ui.busy = true; this.render();
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }).then(function (res) {
      self.ui.busy = false;
      if (!res.ok) { self.ui.error = res.j.description || res.j.message || 'Could not add to cart.'; self.render(); return; }
      self.ui.acked = false; self.render();
      document.dispatchEvent(new CustomEvent('pxg:build-added', { detail: { buildId: id, lines: lines } }));
      if (drawer && res.j.sections && typeof drawer.renderContents === 'function') {
        var inner = drawer.querySelector('.drawer__inner'); if (inner) inner.classList.remove('is-empty');
        drawer.renderContents(res.j);
      } else window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
    }).catch(function () { self.ui.busy = false; self.ui.error = 'Network error – please try again.'; self.render(); });
  };

  // ---------- gallery ----------
  Configurator.prototype.initGallery = function () {
    var g = this.section && this.section.querySelector('[data-pxg-gallery]');
    if (!g) return;
    this.gallery = g;
    var self = this;
    g.addEventListener('click', function (e) { var t = e.target.closest('[data-thumb]'); if (t) self.showMedia(t.getAttribute('data-thumb')); });
    var main = g.querySelector('[data-pxg-gallery-main]');
    if (main && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting && en.intersectionRatio > 0.6) self.markThumb(en.target.getAttribute('data-media-id')); }); }, { root: main, threshold: [0.6] });
      main.querySelectorAll('.pxg-gallery__slide').forEach(function (s) { io.observe(s); });
    }
  };
  Configurator.prototype.markThumb = function (id) {
    if (!this.gallery) return;
    this.gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === id); });
  };
  Configurator.prototype.showMedia = function (id) {
    if (!this.gallery) return;
    var slides = this.gallery.querySelectorAll('.pxg-gallery__slide'), target = null;
    slides.forEach(function (s) { var on = s.getAttribute('data-media-id') === id; s.classList.toggle('is-active', on); if (on) target = s; });
    if (target && window.matchMedia('(max-width: 989px)').matches) target.parentNode.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
    this.markThumb(id);
  };
  Configurator.prototype.showFinishImage = function (finish) {
    if (!this.gallery || !finish) return;
    var f = String(finish).toLowerCase(), hit = null;
    this.gallery.querySelectorAll('.pxg-gallery__slide').forEach(function (s) { if (!hit && (s.getAttribute('data-alt') || '').indexOf(f) >= 0) hit = s; });
    if (hit) this.showMedia(hit.getAttribute('data-media-id'));
  };

  // ---------- mobile buy bar ----------
  Configurator.prototype.initBuyBar = function () {
    var bar = this.section && this.section.querySelector('[data-pxg-buybar]'), self = this;
    if (!bar || !('IntersectionObserver' in window)) return;
    bar.querySelector('[data-pxg-buybar-btn]').addEventListener('click', function () {
      var btn = self.root.querySelector('[data-add]');
      if (btn) btn.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    var visible = true, panelSeen = false;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.target === self.root) panelSeen = en.isIntersecting || en.boundingClientRect.top < 0;
        else visible = en.isIntersecting;
      });
      bar.hidden = visible || !panelSeen;
    });
    io.observe(this.root);
    var watchBtn = function () { var b = self.root.querySelector('[data-add]'); if (b && b !== self._watched) { if (self._watched) io.unobserve(self._watched); io.observe(b); self._watched = b; } };
    watchBtn();
    new MutationObserver(watchBtn).observe(this.root, { childList: true });
  };

  function boot() {
    if (!window.PXGEngine) return setTimeout(boot, 30);
    document.querySelectorAll('[data-pxg-cfg]').forEach(function (root) {
      if (root._pxg) return;
      var dataEl = root.parentNode.querySelector('[data-pxg-cfg-data]');
      if (!dataEl) return;
      try { root._pxg = new Configurator(root, JSON.parse(dataEl.textContent)); }
      catch (e) { if (window.console) console.error('[PXG configurator]', e); root.innerHTML = '<p class="pxg-cfg__note">Sorry, the club builder could not load. Please refresh or contact us to order.</p>'; }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
